import { UPDATE_PAGE_HEAD } from '../actions/head'

const head = (state = {}, action = {}) => {
  switch (action.type) {
    case UPDATE_PAGE_HEAD:
      state = action.payload
      break
  }
  return state
}

export default head
